/*
 * File: common.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-30 5:26:13 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

/** 请求路径 */

// 基础路径判断
let protocol = window.location.protocol; // 协议
// 测试环境，域名的时候 http://cmms2.midea.com/
let baseApi = process.env.BASE_API;
let prefixMeiju = '/dcpServiceOpmange/supervisor';
if (window.location.href.indexOf('://cmms2') >= 0) {
  baseApi = 'http://cmms2.midea.com/';
}
if (protocol === 'https:') {
  baseApi = baseApi.replace('http:', 'https:');
}

/** 公共接口 */
// 公共组件-数据字典
export const DICT_SELECT_LIST = '/cmms/common/dicValueList';
// 获取不同菜单、不同用户的下拉框字典值
export const MENU_DICTIONARY_LIST = '/cmms/newRole/menuDictionaryList';
// 上传图片
export const UPLOAD_IMG = baseApi + '/cmvip/uploadApi/upload';
// 上传图片到OSS
export const UPLOAD_IMG_OSS = baseApi + '/cmvip/uploadApi/uploadToOSS';
// 上传图片修改
const URL = (process.env.ENV_CONFIG === 'dev' ? '/test' : '') + prefixMeiju + '/post/upload';
export const UPLOAD_IMG_DIRECT_TO_OSS = baseApi + '/cmvip/uploadApi/directUploadToOss?type=exchangeorder';
export const COMMON_UPLOAD_IMG_DIRECT_TO_OSS = baseApi + '/cmvip/uploadApi/directUploadToOss?type=';
export const UPLOAD_IMG_DIRECT_TO_OSS_URL = '/cmvip/uploadApi/directUploadToOss?type=exchangeorder';
// 新增话题上传
export const TOPIC_UPLOAD_IMG_DIRECT_TO_OSS = URL;
// 获取城市键值接口
export const GET_AREA_LIST = '/cmms/area/list';
// 购买订单平台
export const GET_BUY_PLAT_FORM = '/ccrm2/support/getBuyPlatform';
// 获取购买商品品类 大类
export const GET_PRODUCT_TYPE = '/ccrm2/support/getProductType';
// 获取购买商品品类 小类
export const GET_PRODUCT_SUB_TYPE = '/ccrm2/support/getProductSubType';
// 家电登记 获取品牌
export const SUPPORT_GET_BRAND = '/ccrm2/support/getBrand';
// 家电登记 大类 小类获取
export const GET_CSS_PRODUCT_TYPE = '/ccrm2/support/getCssProductType';
// 获取权限的品牌
export const AUTH_GET_BRAND = '/cmms/auth/getBrand';
// 成长规则、积分规则级联获取
export const GET_POINT_GROW_LIST = '/cmvip/integralRuleApi/getPointGrowKeyList';
// 查询微信公众号
export const GET_WXCHAT_LIST = '/ccrm2/wxOfficialAccount/list';

/** 旧平台接口 */
// 旧平台图片上传（广告投放）
export const AD_IMG_UPLOAD = baseApi + 'cmad/editAd/uploadBannerPic';

/** 数据中控平台接口 */
// 字典子列表获取
export const DICT_ITEM_LIST_URL = prefixMeiju + '/adPosition/getItemList';
// 广告管理-获取大屏
export const DICT_SCREEN_ITEM_LIST_URL = prefixMeiju + '/secretkey/getScreenModel';
// 获取秘钥vcode
export const GET_VCODE = prefixMeiju + '/secretkey/getvecode';
// 获取秘钥vcode
export const GET_SDAPP_VERSION = prefixMeiju + '/secretkey/getSdappVersion';
// 获取当前服务器时间
export const GET_SYSTEM_TIME = '/cmms/auth/getSystemTime';
// 一次性获取所有的省市区
export const AREA_SELECT_EXCEPT_STREET = '/cmms/area/selectExceptStreet';


/** 公告 */
// 获取公告列表
export const NOTICE_SELECT_NOTICE_LIST = '/cmms/notice/selectNoticeList';
// 新增修改公告
export const NOTICE_INSET_OR_UPDATE_NOTICE = '/cmms/notice/insertOrUpdateNotice';
// 公告的开启和禁用
export const NOTICE_CHANGE_NOTICE_ENABLED = '/cmms/notice/changeNoticeEnabled';
